<template>
  <div
    id="app"
    class="bg"
    :class="bindStatus()"
  >
    <div
      class="header"
      :class="bindStatus()"
    >
      <div
        class="header-flex"
      >
        <div
          class="header-button button-run"
          :class="bindStatus()"
          @click="runWing"
          @touchstart="touchStart"
          @touchend="touchEnd"
        >
          <div
            v-if="wingStartTime"
            class="center-elem"
          >
            <font-awesome-icon
              icon="fa-solid fa-person-running"
              class="run-icon"
            />
            <span class="run-str">RUNNING</span>
          </div>
          <div
            v-else
            class="center-elem"
          >
            <font-awesome-icon
              icon="fa-solid fa-feather"
              class="run-icon"
            />
            <span class="run-str">START</span>
          </div>
        </div>

        <div
          v-if="wingStartTime"
          class="header-button button-stop"
          :class="bindStatus()"
          @click="stopWing"
          @touchstart="touchStart"
          @touchend="touchEnd"
        >
          <div class="center-elem">
            <font-awesome-icon
              icon="fa-solid fa-mug-hot"
              class="mug-icon"
            />
          </div>
        </div>
      </div>
      <div class="header-flex">
        <div
          class="header-button button-view"
          :class="bindStatus()"
          @click="changeView"
          @touchstart="touchStart"
          @touchend="touchEnd"
        >
          <div class="center-elem">
            <font-awesome-icon
              v-if="isTimer"
              icon="fa-solid fa-chart-column"
              class="view-icon"
            />
            <font-awesome-icon
              v-else
              icon="fa-solid fa-stopwatch"
              class="view-icon"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isTimer"
      ref="run"
      class="main"
      @click="clicked"
    >
      <TimerView
        :waittime="waitTimeStr"
        :lockwaittime="lockWaitTimeStr"
        :locked="locked"
        :count="count"
      />
    </div>
    <div
      v-else
      class="main"
    >
      <SummaryView
        :wingtime="wingTimeStr"
        :runresult="runResultArr"
        @updateresult="updateResult"
      />
      <SettingsComponent
        :cct="continuousClickThreshold"
        @updatecct="updateCCT"
      />
      <HowTo />
    </div>
  </div>
</template>

<script>
import * as moment from 'moment-timezone';
import isMobile from 'ismobilejs'

import TimerView from "./components/TimerView.vue"
import SummaryView from "./components/SummaryView.vue"
import HowTo from "./components/HowTo.vue"
import SettingsComponent from "./components/SettingsComponent.vue"

export default {
  name: 'App',
  components: { TimerView, SummaryView, SettingsComponent, HowTo },
  data: function(){
    return {
      interval: 30000,
      lockInterval: 300000,
      intervalId: null,
      locked: false,
      startTime: null,
      waitTimeStr: "GO",
      lastClickTime: null,
      continuousClickThreshold: 0,
      contiunuousClickTimes: 0,
      lockedTime: null,
      lockWaitTimeStr: "WAIT",
      count: 0,
      isTimer: true,
      wingStartTime: null,
      wingTimeStr: "",
      runResultArr:[],
      keyDetected:false,
    }
  },
  computed: {
    mobile() {
      return isMobile(window.navigator).any;
    }
  },
  mounted: function(){
    this.setFillHeight();
    this.loadStorage();

    this.intervalId = setInterval(() => {
      this.updateWaitTime();
    }, 10)
    window.addEventListener('keydown', this.keyDown)
    window.addEventListener('resize', this.setFillHeight)
  },
  beforeUnmount: function(){
    window.removeEventListener('keydown', this.keyDown)
    window.removeEventListener('resize', this.setFillHeight)
  },
  methods: {
    clicked: function(){
      const now = Date.now()
      if(this.count == 0){
        this.startTime = now
      }
      this.count++
      if(this.count > 3 && now - this.startTime < this.interval){
        this.locked = false
        this.count = 2
      }
      if (this.lastClickTime && now - this.lastClickTime < this.continuousClickThreshold) {
        this.contiunuousClickTimes++
        if (this.contiunuousClickTimes > 2) {
          this.reset()
        }
      } else {
        this.contiunuousClickTimes = 1
      }
      this.lastClickTime = now
    },
    keyDown: function(e){
      if (e.ctrlKey || e.metaKey) return
      if (e.keyCode == 32 || e.keyCode == 13) {
        this.clicked();
      } else if (e.keyCode == 46 || e.keyCode == 8 || e.keyCode == 27) {
        this.reset();
      } else if (e.keyCode == 82) {
        if (this.wingStartTime) {
          this.keyDetected = true
          setTimeout(() => {this.keyDetected = false}, 100)
        }
        this.runWing();
      } else if (e.keyCode == 83) {
        this.stopWing();
      }
    },
    reset: function(){
      this.startTime = null
      this.locked = false
      this.lockedTime = null
      this.waitTimeStr = "GO"
      this.lockWaitTimeStr = "WAIT"
      this.count = 0
      this.lastClickTime = null
      this.contiunuousClickTimes = 0
    },
    updateWaitTime: function(){
      const now = Date.now()
      if (this.wingStartTime) {
        this.wingTimeStr = moment(now - this.wingStartTime).tz("GMT").format("H:mm:ss")
      } else {
        this.wingTimeStr = ''
      }
      if (!this.startTime) return
      if (this.count < 1) return
      const takenTime = now - this.startTime
      
      if (this.count > 2) {
        this.locked = true
        if (!this.lockedTime) {
          this.lockedTime = now
        }
        const takenLockTime = now - this.lockedTime
        if ( takenLockTime < this.lockInterval) {
          this.lockWaitTimeStr = moment(this.lockInterval - takenLockTime).format("m:ss.S")
        } else {
          this.reset()
        }
      } else {
        if ( takenTime < this.interval) {
          this.waitTimeStr = moment(this.interval - takenTime).format("s.S")
        } else {
          this.reset()
        }
      }
    },
    setFillHeight: function(){
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    runWing: function(){
      const now = Date.now()
      if (this.wingStartTime) {
        this.stopWing()
      }
      this.wingStartTime = now
      this.saveStorage()
    },
    stopWing:function(){
      if(this.wingStartTime) {
        const now = Date.now()
        const obj = {
          'start': this.wingStartTime,
          'end': now
        }
        this.runResultArr.push(obj)
        this.wingStartTime = null
        this.saveStorage()
      }
    },
    changeView:function(){
      this.isTimer = !this.isTimer
    },
    switchHideWingTimer: function(){
      this.isHidingWing = !this.isHidingWing
    },
    saveStorage:function(){
      const saveObj = {
        'runResultArr': this.runResultArr,
        'wingStartTime': this.wingStartTime,
        'clickThreshold': this.continuousClickThreshold
      }
      const saveJson = JSON.stringify(saveObj)
      localStorage.setItem('data', saveJson)
    },
    loadStorage: function(){
      let loadJson = localStorage.getItem('data')
      if (!loadJson){
        this.saveStorage()
        loadJson = localStorage.getItem('data')
      }
      const loadObj = JSON.parse(loadJson)
      
      this.runResultArr = loadObj['runResultArr'] ? loadObj['runResultArr'] : []
      this.wingStartTime = loadObj['wingStartTime'] ? loadObj['wingStartTime'] : null
      this.continuousClickThreshold = loadObj['clickThreshold'] ? loadObj['clickThreshold'] : 0
    },
    updateResult:function(newVal) {
      this.runResultArr = newVal
      this.saveStorage()
    },
    updateCCT:function(newVal) {
      this.continuousClickThreshold = newVal
      this.saveStorage()
    },
    touchStart(e){
      e.currentTarget.classList.add('touched');
    },
    touchEnd(e){
      e.currentTarget.classList.remove('touched');
    },
    bindStatus: function(){
      const status = {
        'count0': this.count == 0,
        'count1': this.count == 1,
        'count2': this.count == 2,
        locked: this.count > 2,
        pc: !this.mobile,
        keyDetected: this.keyDetected
      }
      return status
    }
  }
}
</script>

<style lang="scss">
@import url("assets/css/font.css");

body {
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}

.header {
  width: 100%;
  height: 66px;
  display: flex;
  background-color: white;
  color: white;
  overflow: hidden;
  justify-content: space-between;
  &.locked{
    background-color: #fff100;
    color: #fff100;
  };
}

.header-flex {
  display: flex;
  padding-bottom: 2px ;
}

.header-button {
  height: 60px;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  &.count0{
    background-color: #4dc4ff;
    &.pc {
      &:hover {
        background-color: white;
        color: #4dc4ff;
        border: 1px solid #4dc4ff;
      }
    }
    &.touched {
      background-color: white;
      color: #4dc4ff;
      border: 1px solid #4dc4ff;
    }
    &.keyDetected {
      background-color: white;
      color: #4dc4ff;
      border: 1px solid #4dc4ff;
    }
  }
  &.count1{
    background-color: #fff100;
    color: #2c3e50;
    &.pc {
      &:hover {
        background-color: #2c3e50;
        color: #fff100;
        border: 1px solid #fff100;
      }
    }
    &.touched {
      background-color: #2c3e50;
      color: #fff100;
      border: 1px solid #fff100;
    }
    &.keyDetected {
      background-color: #2c3e50;
      color: #fff100;
      border: 1px solid #fff100;
    }
  }
  &.count2{
    background-color: #ff4b00;
    &.pc {
      &:hover {
        background-color: white;
        color: #ff4b00;
        border: 1px solid #ff4b00;
      }
    }
    &.touched {
      background-color: white;
      color: #ff4b00;
      border: 1px solid #ff4b00;
    }
    &.keyDetected {
      background-color: white;
      color: #ff4b00;
      border: 1px solid #ff4b00;
    }
  }
  &.locked{
    background-color: #ff4b00;
    color: #fff100;
    &.pc {
      &:hover {
        background-color: #fff100;
        color: #ff4b00;
        border: 1px solid #ff4b00;
      }
    }
    &.touched {
      background-color: #fff100;
      color: #ff4b00;
      border: 1px solid #ff4b00;
    }
    &.keyDetected {
      background-color: #fff100;
      color: #ff4b00;
      border: 1px solid #ff4b00;
    }
  }
}

.button-run {
  width: 160px;
}
.button-stop {
  width: 60px;
  margin-left: 8px;
}
.button-view {
  width: 60px;
}

.bg{
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  &.count0 {
  background-color: #4dc4ff;
  }
  &.count1 {
  background-color: #fff100;
  color: #2c3e50;
  }
  &.count2 {
  background-color: #ff4b00;
  }
  &.locked {
    background-color: #ff4b00;
    &:before{
      content: '\e900';
      color: #fff100;
      font-size: min(calc((var(--vh, 1vh) * 100 - 66px) * 0.8), 80vw);
      font-family: icomoon;
      margin: 0px;
      position:absolute;
      top:calc(66px + (var(--vh, 1vh) * 100 - 66px) * 0.5);
      left:50%;
      transform:translate(-50%,-50%);
      width:100%;
    }
  }
}

.main{
  width: 100%;
  height: calc(var(--vh, 1vh) * 100 - 66px);
  top: 66px;
  left: 0px;
  position:absolute;
  overflow: auto;
}

.center-elem {
  margin: 0px;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  width:100%;
}

.run-icon {
  font-size: 1.5em;
  margin-right: 0.3em;
}
.run-str {
  font-size: 20px;
}

.mug-icon {
  font-size: 1.5em;
}
.view-icon {
  font-size: 1.5em;
}

.settings {
  text-align: left;
  width: calc(94vw - 40px);
  padding: 20px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: rgba(255,255,255,0.9);
  overflow: hidden;
  border:1px solid black;
}


</style>
